import KoobTooltip from '../../components/KoobTooltip';
import type { AssignCounterProps } from './types';

export type { AssignCounterProps };

export function AssignCounter({ label, mismatch, tip }: AssignCounterProps) {
  const text = (
    <span className={mismatch ? 'font-medium text-red-500' : undefined}>
      {label}
    </span>
  );
  if (!mismatch) return text;
  return (
    <KoobTooltip side="left" tip={tip}>
      {text}
    </KoobTooltip>
  );
}
